const t = (e) => ({
  ar: "54",
  at: "43",
  au: "61",
  be: "32",
  br: "55",
  ca: "1",
  ch: "41",
  cl: "56",
  co: "57",
  cr: "506",
  cz: "420",
  de: "49",
  dk: "45",
  ec: "593",
  es: "34",
  fi: "358",
  fr: "33",
  gb: "44",
  gr: "30",
  gt: "502",
  hk: "852",
  hu: "36",
  id: "62",
  ie: "353",
  il: "972",
  in: "91",
  it: "39",
  jp: "81",
  kr: "82",
  lt: "370",
  lu: "352",
  mx: "52",
  my: "60",
  nl: "31",
  no: "47",
  nz: "64",
  pe: "51",
  ph: "63",
  pl: "48",
  pt: "351",
  ro: "40",
  se: "46",
  sg: "65",
  sv: "503",
  th: "66",
  tr: "90",
  tw: "886",
  us: "1",
  vn: "84",
  za: "27"
})[e];
export {
  t as default
};
